<template>
  <div class="projects container-fluid">
    <div class="col-10 text">
      <h2>
        KLASA, SZYK I PIĘKNO TO PODSTAWOWE ZALETY KOLEKCJI STYLIZOWANEJ.
        ZRÓŻNICOWANA KOLORYSTYKA I NIEBANALNE WZORY PODKREŚLĄ WNĘTRZE I NADADZĄ
        MU LUKSUSOWY CHARAKTER.
      </h2>
      <p>
        To kolekcja powstała dla Klientów, którzy ponad wszystko cenią sobie
        wyszukane, oryginalne rozwiązania. Oferowane przez nas podłogi
        stylizowane kreowane są nieskończonym bogactwem wzorów i kolorów, a
        dodatkowo cechują się wyraźnie zaznaczonym rysunkiem drewna. To wszystko
        zapewnia wyjątkowy efekt dekoracyjny i podkreśla niepowtarzalny
        charakter deski. Wierzymy, że tak zróżnicowany wybór drewnianych
        posadzek pozwoli Państwu na dobranie produktu, który będzie doskonale
        dopasowany do wystroju wnętrz w Państwa domu. Kolekcja wzorów ręcznie
        malowanych oraz szczotkowanych podłóg, połączenie klasyki z
        nowoczesnością i różnorodnością wzorów. Proces szczotkowania, czyli
        wybrania miękkiej części drewna, podkreślając tym samym usłojenie daje
        niezwykłe efekty. Pozwala to uzyskać różnorodność kolorów niedostępnych
        na deskach gładkich. Deski wykańczane oraz malowane ręcznie, co tylko
        podkreśla ich wyjątkowość i wartość. Bez wątpienia nasza ręcznie
        postarzana podłoga nadaje każdemu domowi niepowtarzalny charakter i
        przytulny klimat, dzięki któremu każdy z momentem przekroczenia progu
        Państwa czterech ścian odczuwa atmosferę sprzyjającą dobremu
        samopoczuciu.
      </p>
    </div>
    <div
      v-scrollanimation
      class="image col-10 col-sm-5 col-md-4 col-xl-3"
      v-for="(image, index) in media"
      :key="index"
      @click="openGallery(index)"
      :style="{
        width: 'auto',
        height: '17rem'
      }"
    >
      <img v-lazy="image.src || image.thumb" @click="openGallery(index)" />
      <h3>{{ image.caption }}</h3>
    </div>

    <LightBox
      ref="lightbox"
      :media="media"
      :show-caption="true"
      :show-light-box="false"
    />
  </div>
</template>

<script>
require("vue-image-lightbox/dist/vue-image-lightbox.min.css");
import Images from "./styled.js";
import LightBox from "vue-image-lightbox";
export default {
  data: function() {
    return {
      index: null,
      media: Images
    };
  },
  methods: {
    openGallery(index) {
      this.$refs.lightbox.showImage(index);
    }
  },

  components: {
    LightBox
  }
};
</script>
<style scoped>
.text {
  text-align: center;
  margin-top: 2%;
}
.projects {
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

.image {
  height: auto;
  display: inline-block;
  position: relative;
  transition: 0.3s;
  margin: 1%;
}

.image img {
  width: 100%;
  height: 100%;
  transition: 0.3s;
  border-radius: 4px;
}

.image:hover img {
  filter: blur(2px) brightness(60%);
  box-shadow: 0 0 16px rgb(32, 28, 28);
  cursor: pointer;
}

.image :not(img) {
  position: absolute;
  z-index: 1;
  width: 90%;
  top: 50%;

  left: 5%;
  color: #fff;
  opacity: 0;
  transition: 0.3s;
}

.image:hover :not(img) {
  cursor: pointer;
  opacity: 1;
}
</style>
